import { IBaseMigrationStaffer } from '../../../interfaces';
import { StaffToUserMappingHandler } from '../../../mappings/staff-to-user';
import {
  IPraktikaStaffer,
  PraktikaStaffer,
  StafferSourceEntity,
} from '../../source/entities/staff';

export class PraktikaStaffToUserMappingHandler extends StaffToUserMappingHandler<
  PraktikaStaffer,
  StafferSourceEntity
> {
  override sourceEntity = new StafferSourceEntity();
  translateFn = (record: IPraktikaStaffer): IBaseMigrationStaffer => ({
    id: record.id,
    name: `${record.first_name} ${record.last_name}`,
    providerNo: record.provider_number,
  });
}
